<template>
    <router-view />
</template>

<script>

export default {
    name: 'AppLayout',
    components: {
    }
}
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/layout/Index.vue